import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { createAgreementV8, createDirectDebitMandateV4, getDirectDebitMandatesV4 } from 'api'
import { ALL_AGREEMENTS } from 'api/react-query/keys'
import {
  type CreateDirectDebitAgreement,
  type CreateDirectDebitAutogiro,
  type CreateDirectDebitOverforselService,
  type CreateNorwegianDirectDebitAgreement,
  type CreateSepaDirectDebit,
  mapCreateAgreementV8Request,
  mapCreateDirectDebitMandateV4Request,
  mapDirectDebitMandate,
} from './mappers'

export const DIRECT_DEBIT_MANDATE = 'DIRECT_DEBIT_MANDATE'
export const CREATE_DEBIT_MANDATE = 'CREATE_DEBIT_MANDATE'

export const useDirectDebitMandates = (customerId: string) =>
  useQuery({
    queryKey: [DIRECT_DEBIT_MANDATE, customerId],
    queryFn: () => getDirectDebitMandatesV4(customerId).then((mandates) => mandates.map(mapDirectDebitMandate)),
  })

export const useCreateDirectDebitMandateV4 = (customerId: string) =>
  useMutation({
    mutationKey: [CREATE_DEBIT_MANDATE, customerId],
    mutationFn: (data: CreateDirectDebitOverforselService | CreateDirectDebitAutogiro | CreateSepaDirectDebit) =>
      createDirectDebitMandateV4(customerId, mapCreateDirectDebitMandateV4Request(data)),
  })

export const useCreateDirectDebitMandateV8 = (customerId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: [CREATE_DEBIT_MANDATE, customerId],
    mutationFn: (data: CreateDirectDebitAgreement | CreateNorwegianDirectDebitAgreement) =>
      createAgreementV8(customerId, mapCreateAgreementV8Request(data)),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [ALL_AGREEMENTS],
      })
    },
  })
}
